class Megamenu extends Component {
    constructor(el) {
        super(el);
        this.mainNav = document.querySelector('[data-component="AppNavigation"]')
        this.closeMove = this.$find('[data-megamenu-close]');
        this.sortimentLink = document.querySelector('[data-sortiment]');
        this.sortimentLinkArrow = document.querySelector('[data-sortiment] [data-sortiment-opener]');
        this.body = document.querySelector('body');
        this.addEventListeners();
    }

    openMegamenuDesktop() {
        //this.body.classList.add('is-not-overflowed');
        this.body.classList.add('has-shade-bg');
        this.$el.classList.add('is-opened');
    }

    closeMegamenuDesktop() {
        //this.body.classList.remove('is-not-overflowed');
        this.body.classList.remove('has-shade-bg');
        this.$el.classList.remove('is-opened');
    }

    openMoveMegamenu() {
        this.mainNav.classList.add('is-moved');
    }

    closeMoveMegamenu() {
        this.mainNav.classList.remove('is-moved');
    }

    addEventListeners() {
        this.sortimentLink.addEventListener('mouseenter', () => this.openMegamenuDesktop());
        this.sortimentLink.addEventListener('mouseleave', () => this.closeMegamenuDesktop());
        this.$el.addEventListener('mouseenter', () => this.openMegamenuDesktop());
        this.$el.addEventListener('mouseleave', () => this.closeMegamenuDesktop());
        this.sortimentLinkArrow.addEventListener('click', () => this.openMoveMegamenu());
        this.closeMove.addEventListener('click', () => this.closeMoveMegamenu());
    }
}